import { COLORS } from '@/styles/colors';
import { bodySmall2, caption, poppinsSemiBoldFont } from '@/styles/typography';
import styled from 'styled-components';

export const PillsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Pill = styled.button<{ $active?: boolean }>`
  ${bodySmall2};
  ${poppinsSemiBoldFont};
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid ${({ $active }) => ($active ? COLORS.black : COLORS.grey[400])};
  background-color: ${({ $active }) => ($active ? COLORS.black : COLORS.white)};
  color: ${({ $active }) => ($active ? COLORS.white : COLORS.grey[700])};
  cursor: pointer;
  white-space: nowrap;

  ${({ $active }) =>
    !$active &&
    `
    &:hover {
      border-color: ${COLORS.grey[650]};
      background-color: ${COLORS.grey[150]};
    }
  `}
`;

export const PillCount = styled.span`
  ${caption};
  margin-left: 6px;
  color: ${COLORS.grey[600]};
`;
